/**
 * The upgrade offer behind every paywall (ROADMAP 0.R R2). Mounted once; opens
 * the plan modal for the plan that lifts the refusal, with the server's own
 * sentence above it. The page that was refused still shows its line — this
 * adds the way past it. The same offer is not shown twice within a minute, so
 * a retried request does not nag.
 */
import React, { useEffect, useRef, useState } from 'react';

import analyticsService from '../../services/analytics';
import type { PaidPlan } from '../../services/billingService';
import { useSubscriptionStore } from '../../stores/subscriptionStore';
import { planToOffer, UPGRADE_EVENT, UpgradeOfferDetail } from '../../utils/upsell';
import PlanRevealModal from './PlanRevealModal';

export const REOFFER_AFTER_MS = 60_000;

const UpgradeOffer: React.FC = () => {
  const [offer, setOffer] = useState<{ plan: PaidPlan; reason: string } | null>(null);
  const last = useRef<Record<string, number>>({});

  useEffect(() => {
    const onOffer = (e: Event) => {
      const { code, message } = (e as CustomEvent<UpgradeOfferDetail>).detail || ({} as UpgradeOfferDetail);
      const plan = planToOffer(code, useSubscriptionStore.getState().plan);
      if (!plan) return;
      const now = Date.now();
      if (now - (last.current[code] || 0) < REOFFER_AFTER_MS) return;
      last.current[code] = now;
      analyticsService.trackPaywallMoment('shown', plan, { code });
      setOffer({ plan, reason: message });
    };
    window.addEventListener(UPGRADE_EVENT, onOffer);
    return () => window.removeEventListener(UPGRADE_EVENT, onOffer);
  }, []);

  return <PlanRevealModal open={!!offer} plan={offer?.plan ?? null} reason={offer?.reason} onClose={() => setOffer(null)} />;
};

export default UpgradeOffer;
